import request from '@/utilsCloud/request'
import port from './port'

// 获取考试列表
export function entpExamList(query) {
  return request({
    url: port.exam + '/exercise/entpExamList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 点击判断结果后进行的操作
export function exerciseDetailVerification(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetailVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 去往考试页面
export function getEntpExamConfigCurrent(query) {
  return request({
    url: port.exam + '/examConfig/getEntpExamConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 判断是否学完课程才能学习
export function getEmployeeCourseOverStatus(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getEmployeeCourseOverStatus',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 跳到考试页面
export function exerciseDetail(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/testList.js